var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$wf.isSmDown
    ? _c(
        "app-mobile-full-screen-container",
        [
          _c(
            "app-toolbar",
            { attrs: { "drawer-button-disabled": "" } },
            [
              _c(
                "w-toolbar-text",
                {
                  staticClass: "app-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.deleteEvent()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-card", "tag-attributes": { grow: true } } },
            [
              _c(
                "w-card-content",
                { staticStyle: { "flex-grow": "1" } },
                [_vm._t("default")],
                2
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "w-card",
        { attrs: { "max-width": _vm.maxWidth } },
        [
          _c(
            "w-card-title",
            { attrs: { plain: "", subtitle: _vm.subtitle } },
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _c("w-spacer"),
              _c("w-button", {
                attrs: { flat: "", round: "", icon: "times" },
                on: {
                  click: function ($event) {
                    return _vm.cancel()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { staticClass: "body", attrs: { tag: "w-card-content" } },
            [_vm._t("default")],
            2
          ),
          _c(
            "w-card-actions",
            { staticClass: "actions" },
            [
              _vm.deletable
                ? _c(
                    "w-button",
                    {
                      staticClass: "danger",
                      attrs: { ghost: "", icon: "trash" },
                      on: {
                        click: function ($event) {
                          return _vm.deleteEvent()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("delete-event")) + " ")]
                  )
                : _vm._e(),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel mr",
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
              ),
              _c(
                "w-button",
                {
                  attrs: { icon: "save" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }